import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ACCOUNT_TYPE } from '../../constants/PaymentTypes';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
import { createMOP } from '../../redux/PaymentState/PaymentState.actions';
import { PAYMENT_PROCESSOR_TYPE } from '@chegg/checkout-sdk';
/* Verify User provided billing address from third party Payment methods (paypal, applepay) */

export var verifyUserProvidedBillingAddress = function verifyUserProvidedBillingAddress(params) {
  var thirdPartyBraintreePayload = params.thirdPartyBraintreePayload,
    billingAddress = params.billingAddress,
    dispatch = params.dispatch,
    deviceData = params.deviceData;
  var nonce = thirdPartyBraintreePayload.nonce,
    details = thirdPartyBraintreePayload.details;
  // set "updatedBillingAddress" updated address (city, state, zip and country) values
  var updatedBillingAddress = _objectSpread({}, billingAddress);
  var userProvidedBillingAddress = details.billingAddress,
    firstName = details.firstName,
    lastName = details.lastName;

  // if user provided address has line1 and line 2 values, add them to "updatedBillingAddress"
  var line1 = userProvidedBillingAddress === null || userProvidedBillingAddress === void 0 ? void 0 : userProvidedBillingAddress.line1;
  var line2 = userProvidedBillingAddress === null || userProvidedBillingAddress === void 0 ? void 0 : userProvidedBillingAddress.line2;
  updatedBillingAddress = _objectSpread(_objectSpread({}, updatedBillingAddress), {}, {
    line1: line1,
    line2: line2
  });

  // if User Address was able to successfully verify the address, continue to add this MOP
  dispatch(createMOP({
    nonce: nonce,
    details: details,
    name: "".concat(firstName, " ").concat(lastName),
    accountType: ACCOUNT_TYPE.PAYPAL_TOKEN,
    paymentProcessor: PAYMENT_PROCESSOR_TYPE.BRAINTREE,
    deviceData: deviceData,
    billing: _objectSpread({}, updatedBillingAddress)
  }));

  // take user back to normal Payment Methods view.
  dispatch(saveConfigs({
    didAddressUpdate: false
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/VerifyAddress/verifyUserProvidedBillingAddress.js
// module id = 4562
// module chunks = 11